module.exports = __webpack_public_path__ + "assets/img/WechatIMG54.a6e38f4e.png";